import React from 'react';
import { Skeleton, Box } from '@mui/material';
import { Grid } from '@mui/material';

export const InspectionFilterSkeleton: React.FC = () => {
    return (
        <Box
            sx={{
                width: '100%',
                borderRadius: 1,
                padding: 2,
                boxShadow: 2,
                backgroundColor: '#fff'
            }}
        >
            <Skeleton variant="rectangular" width="100%" height={44} sx={{ mb: 2 }} />

            {/* Dropdown */}
            <Skeleton variant="rectangular" width="100%" height={44} sx={{ mb: 2 }} />

            {/* Date Range */}
            <Grid container spacing={2}>
                <Grid size={5}>
                    <Skeleton variant="rectangular" width="100%" height={44} />
                </Grid>
                <Grid size={2} display="flex" justifyContent="center" alignItems="center">
                </Grid>
                <Grid size={5}>
                    <Skeleton variant="rectangular" width="100%" height={44} />
                </Grid>
            </Grid>
        </Box>
    );
};
